import { useTranslation } from "react-i18next"
import { Typography } from "@material-ui/core"
import EmptyPage from "../common/EmptyPage"
import { ReactComponent as EmptyPath } from "../images/empty-path.svg"

const PathEmpty = () => {
    const { t } = useTranslation()

    return (
        <EmptyPage>
            <EmptyPath />
            <div>
                <Typography className="text-center mb-4">{t(`You have no path yet`)}</Typography>
            </div>
        </EmptyPage>
    )
}

export default PathEmpty
